import React, { useState } from 'react';
import PropTypes from 'prop-types';
// material-ui
import Checkbox from '@material-ui/core/Checkbox';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
// css
import './SelectionControl.scss';

const SelectionControl = ({
    legend, name, label, value, onChange, children, disabled, checkbox, checked, toggleswitch, ios, onToogleCheck
}) => {
    const [ischecked, setCheck] = useState(checked);
    
    const handleChange = (event) => {
        setCheck( event.target.checked );
        onToogleCheck(event.target.checked);
    };

    if(checkbox) { 
        return (
            <FormControl component="fieldset" className="SelectionControl Checkbox">
                {legend && <div className='label'>{legend}</div>}
                <FormControlLabel
                    control={
                        <Checkbox
                            disabled={disabled}
                            checked={ ischecked }
                            onChange={ handleChange }
                            value= { value }
                            className={ischecked ? 'checked' : ''} 
                        />
                    }
                    label= { label }
                />
            </FormControl>
        );
    }
    if(toggleswitch) {
        return (
            <FormControl component="fieldset" className="SelectionControl">
                {legend && <div className='label'>{legend}</div>}
                <FormControlLabel component="fieldset" className="SelectionControl"
                    control= {
                        <Switch
                            disabled={disabled}
                            checked={ischecked}
                            onChange={handleChange}
                            value={value}
                            classes={{
                                switchBase: `${ios ? 'iosbase':'asds'}`,
                                checked: `${ios ? 'iosbase':'checked'}`,
                                bar: `${ios ? 'iosbase':'bar'}`,
                                icon: `${ios ? 'iosbase':''}`,
                                iconChecked: `${ios ? 'iosbase':''}`,
                            }}
                        />
                    }
                    label={label}
                />
            </FormControl>
        );
    }
    
    return (
        <FormControl component="fieldset" className="SelectionControl">
            {legend && <div className='label'>{legend}</div>}
            <RadioGroup
                aria-label= { name }
                name= { name }
                className="RadioGroup"
                value={value}
                onChange={ onChange }
            >
                {children}
            </RadioGroup>
        </FormControl>
    );
}

SelectionControl.propTypes = {
    name: PropTypes.string,
	label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    legend: PropTypes.string,
    children: PropTypes.instanceOf(Object),
    disabled: PropTypes.bool,
    checkbox: PropTypes.bool,
    toggleswitch: PropTypes.bool,
    ios: PropTypes.bool,
    onToogleCheck: PropTypes.func
};

SelectionControl.defaultProps = {
    name: '',
    label: '',
    value: '',
    onChange: () => {},
    checked: false,
    legend: '',
    children: {},
    disabled: false,
    checkbox: false,
    toggleswitch: false,
    ios: false,
    onToogleCheck: PropTypes.func
};

export default SelectionControl;

// colorSwitchBase: {
//     color: purple[300],
//     '&$colorChecked': {
//       color: purple[500],
//       '& + $colorBar': {
//         backgroundColor: purple[500],
//       },
//     },
//   },
//   colorBar: {},
//   colorChecked: {},
//   iOSSwitchBase: {
//     '&$iOSChecked': {
//       color: theme.palette.common.white,
//       '& + $iOSBar': {
//         backgroundColor: '#52d869',
//       },
//     },
//     transition: theme.transitions.create('transform', {
//       duration: theme.transitions.duration.shortest,
//       easing: theme.transitions.easing.sharp,
//     }),
//   },
//   iOSChecked: {
//     transform: 'translateX(15px)',
//     '& + $iOSBar': {
//       opacity: 1,
//       border: 'none',
//     },
//   },
//   iOSBar: {
//     borderRadius: 13,
//     width: 42,
//     height: 26,
//     marginTop: -13,
//     marginLeft: -21,
//     border: 'solid 1px',
//     borderColor: theme.palette.grey[400],
//     backgroundColor: theme.palette.grey[50],
//     opacity: 1,
//     transition: theme.transitions.create(['background-color', 'border']),
//   },
//   iOSIcon: {
//     width: 24,
//     height: 24,
//   },
//   iOSIconChecked: {
//     boxShadow: theme.shadows[1],
//   },
// });



// WEBPACK FOOTER //
// ./common/Forms/SelectionControl/SelectionControl.js